import React from 'react'
import { Row } from 'react-bootstrap'
import { Button } from '@material-ui/core'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import InfoIcon from '@material-ui/icons/Info'
import CeaInfo from '../../components/CeaInfo'
import CamposPesado0 from '../../components/pesado/CamposPesado0'
import ConfirmarCalle from '../../components/bruto/ConfirmarCalle'
import VolverALeer from '../../components/pesado/VolverALeer'

function PesadoBrutoBalanceroAuto (props) {
  const { cpe, cea, pesoCabezal, pesadoAuto, pesadoEnCabina, altaPesado, showRelectura } = props

  const cereal = cea.cereal
  const claveCereal = cea.claveCereal
  const cerealVariedad = cea.cerealVariedad
  const calificacion = cea.calificacionCereal
  const camion = cea.camion
  const chofer = cea.chofer
  const exportador = cea.exportador
  const pesoBrutoOrigen = cea.pesoBrutoOrigen
  const pesoTaraOrigen = cea.pesoTaraOrigen
  const pesoNetoOrigen = cea.pesoNetoOrigen

  const datosCea = {
    cereal,
    claveCereal,
    cerealVariedad,
    calificacion,
    camion,
    chofer,
    exportador,
    pesoBrutoOrigen,
    pesoTaraOrigen,
    pesoNetoOrigen
  }

  const rechazoDeChofer = cpe && cpe.errorDescripcion && cpe.errorDescripcion === 'Rechazo de chofer'

  return (
    <Row className='container-pesado-bruto'>
      <div className='container-info-bruto'>
        <div className='bruto-peso-numero'>
          <div className='container-peso-bruto'>
            <Field
              className='peso-cabezal peso-cabezal-bruto'
              name='pesoBruto'
              component={renderTextField}
              disabled={pesadoAuto}
              label='Peso bruto'
              maxLength={5}
              autoFocus
            />
          </div>
          <form onSubmit={altaPesado} className='campos-cea-destare campos-cea-bruto'>
            <CamposPesado0
              label='Número de CTG'
              disabled={!pesadoEnCabina}
              onBlurInput={props.onBlurInput}
            />
            { pesadoEnCabina
              ? <div>
                <Button
                  className='btn-pesado-destare'
                  size='medium'
                  type='submit'
                  style={{ visibility: 'hidden', display: 'none' }}
                >
                                Siguiente
                </Button>
              </div>
              : null
            }
          </form>
        </div>

        <br />

        { datosCea.cereal && cea.cereal && <CeaInfo cea={datosCea} /> }
        { cea.cereal && !cea.caravana && <div className='msj-info-alerta'>
          <InfoIcon style={{ color: '#ffffff', margin: '0 8px 0 0' }} />
                                        Atención: descarga silo aparte
        </div>
        }

      </div>
      <div className='container-msj-info-bruto'>

        {rechazoDeChofer ? <> ! </> : <></>}

        <ConfirmarCalle
          cpe={cpe}
          datosCea={datosCea}
          pedirConfirmacion={props.pedirConfirmacion}
          handleSubmit={props.submitPesoBruto}
          actualizarCalleVolcadora={props.actualizarCalleVolcadora}
          rechazarPesoBruto={props.rechazarPesoBruto}
          clearFormRechazo={props.clearFormRechazo}
          dialogOpen={props.dialogOpen}
        />

        { pesadoEnCabina && !datosCea.cereal
          ? <div className='msj-info msj-info-pesado-cabina'>
                        Pesado en cabina
            {pesoCabezal ? <h6 style={{ fontWeight: 'bold', marginTop: '8px' }}>
                                        Peso de cabezal: {pesoCabezal}
            </h6>
              : <></>
            }
          </div>
          : <></>
        }

        { (cpe && cpe.numero && showRelectura) || rechazoDeChofer
          ? <VolverALeer
            deleteCpe={props.deleteCpe}
            cpe={cpe}
          />
          : <></>
        }
      </div>
    </Row>
  )
}

export default PesadoBrutoBalanceroAuto
